<template>
  <v-layout row wrap>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.clmRefNo" :label="filtersLabel.clmRefNo" type="tel" :error-messages="errors.collect('clmRefNo')" data-vv-name="clmRefNo" :data-vv-as="filtersLabel.clmRefNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.polNo" :label="filtersLabel.polNo" :error-messages="errors.collect('polNo')" data-vv-name="polNo" :data-vv-as="filtersLabel.polNo" v-validate="'entry|max:16'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-int-mask="{intScale: 11}" v-model="filters.proposalNo" :label="filtersLabel.proposalNo" type="tel" :error-messages="errors.collect('proposalNo')" data-vv-name="proposalNo" :data-vv-as="filtersLabel.proposalNo" v-validate="'numeric'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.clmNo" :label="filtersLabel.clmNo" :error-messages="errors.collect('clmNo')" data-vv-name="clmNo" :data-vv-as="filtersLabel.clmNo" v-validate="'entry|max:16'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.intermediaries" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.products" v-model="filters.product" :label="filtersLabel.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="filtersLabel.product" :error-messages="errors.collect('product')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.busClses" v-model="filters.busCls" :label="filtersLabel.busCls" item-text="label" item-value="value" data-vv-name="busCls" :data-vv-as="filtersLabel.busCls" :error-messages="errors.collect('busCls')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.covers" v-model="filters.cover" :label="filtersLabel.cover" item-text="label" item-value="value" data-vv-name="cover" :data-vv-as="filtersLabel.cover" :error-messages="errors.collect('cover')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.appName" :label="filtersLabel.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="filtersLabel.appName" v-validate="'name|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="params.status" v-model="filters.status" :label="filtersLabel.status" item-text="label" item-value="value" data-vv-name="status" :data-vv-as="filtersLabel.status" :error-messages="errors.collect('status')" clearable></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <transition name="slide-x-transition" mode="out-in">
                    <v-layout row wrap v-if="showDetailFilters">
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-uppercase="filters.vehRegNo" v-model="filters.vehRegNo" :label="filtersLabel.vehRegNo" :error-messages="errors.collect('vehRegNo')" data-vv-name="vehRegNo" :data-vv-as="filtersLabel.vehRegNo" v-validate="'veh_reg_no'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.usrRefId" :label="filtersLabel.usrRefId" :error-messages="errors.collect('usrRefId')" data-vv-name="usrRefId" :data-vv-as="filtersLabel.usrRefId" v-validate="'entry|max:60'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6></v-flex>
                      <v-flex xl3 lg4 xs6></v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.lossFrom" :label="filtersLabel.lossFrom" :data-vv-as="filtersLabel.lossFrom" data-vv-name="lossFrom" :error-messages="errors.collect('lossFrom')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.lossTo" :label="filtersLabel.lossTo" :data-vv-as="filtersLabel.lossTo" data-vv-name="lossTo" :error-messages="errors.collect('lossTo')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryFrom" :label="filtersLabel.entryFrom" :data-vv-as="filtersLabel.entryFrom" data-vv-name="entryFrom" :error-messages="errors.collect('entryFrom')"></cal-picker>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <cal-picker v-model="filters.entryTo" :label="filtersLabel.entryTo" :data-vv-as="filtersLabel.entryTo" data-vv-name="entryTo" :error-messages="errors.collect('entryTo')"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </transition>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-layout row>
        <v-spacer></v-spacer>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <v-btn color="secondary" class="white--text" slot="activator">
            <span>Columns</span>
            <v-icon right dark>mdi-table-column-plus-after</v-icon>
          </v-btn>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
              </template>
              <template v-else>
                No column found
              </template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-layout>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-data-table :headers="listHeaders" :items="items" item-key="clmRefNo" :pagination.sync="pagination" :total-items="totalItems" :loading="loading" class="elevation-1" :rows-per-page-items="itemsPerPage" :no-data-text="noDataText" v-model="selected" select-all>
        <template slot="items" slot-scope="props">
          <td width="50px">
            <v-checkbox primary hide-details v-model="props.selected"></v-checkbox>
          </td>
          <td v-for="column in selectedColumns" :key="column">
            {{props.item[column]}}
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <div>
      <v-btn color="primary" @click="doPromptUpdate" :loading="loading">
        Update to
        <v-icon right>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <div>
      <v-autocomplete :items="this.updateStatusState.statusList" v-model="selectedStatus" v-validate="'required'" label="Status*" item-text="label" item-value="value" data-vv-name="selectedStatus"></v-autocomplete>
    </div>
    <confirm v-model="promptUpdate" @ok="doUpdate">
      Are you sure you want to update selected record(s)?
    </confirm>
  </v-layout>
</template>

<script>
import clone from 'clone'
import { updateStatusMixin } from '../updateStatusMixin'
import { claimStatus } from '@/const/claims'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import { removeTime, setEndTime, formatDisplayDateTime2 } from '@/utils/date'

export default {
  data() {
    return {
      columns: [
        { text: 'Claim Reference No.', align: 'left', value: 'clmRefNo' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Claim No.', value: 'clmNo' },
        { text: 'Proposal No.', align: 'left', value: 'proposalNo' },
        { text: 'Intermediary', value: 'intermediary' },
        { text: 'Product', value: 'product' },
        { text: 'Business Class', value: 'busCls' },
        { text: 'Cover', value: 'cover' },
        { text: 'Status', value: 'status' },
        { text: 'Policy Holder', value: 'appName' },
        { text: 'Registration No.', value: 'vehRegNo' },
        { text: 'Entry Date', value: 'createdDate' },
        { text: 'Loss Date', value: 'lossDate' },
        { text: 'User Ref Id', value: 'usrRefId' }
      ],
      selectedColumns: ['clmRefNo', 'polNo', 'proposalNo', 'appName', 'vehRegNo', 'lossDate', 'status'],
      filtersLabel: {
        clmRefNo: 'Claim Reference No.',
        polNo: 'Policy No.',
        clmNo: 'Claim No.',
        proposalNo: 'Proposal No.',
        intermediary: 'Intermediary',
        product: 'Product',
        busCls: 'Business Class',
        cover: 'Cover Type',
        appName: 'Policy Holder',
        status: 'Status',
        vehRegNo: 'Registration No.',
        lossFrom: 'Loss Date From',
        lossTo: 'Loss Date To',
        entryFrom: 'Entry Date From',
        entryTo: 'Entry Date To',
        usrRefId: 'User Ref Id'
      },
      filters: {
        proposalNo: null,
        clmRefNo: null,
        polNo: null,
        clmNo: null,
        intermediary: null,
        product: null,
        busCls: null,
        cover: null,
        appName: null,
        status: null,
        vehRegNo: null,
        lossFrom: null,
        lossTo: null,
        entryFrom: null,
        entryTo: null,
        usrRefId: null
      },
      params: {
        intermediaries: [],
        products: [],
        status: [],
        busClses: [],
        covers: []
      },
      showDetailFilters: false,
      promptUpdate: false,
      selectedStatus: undefined
    }
  },
  computed: {
    updateStatusState() {
      return this.$store.state.claims.updateStatus
    },
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      return result
    }
  },
  methods: {
    async fetchData(options) {
      if (this.apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: rowsPerPage,
            options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.lossFrom) {
            massageFilters.lossFrom = formatDisplayDateTime2(removeTime(massageFilters.lossFrom))
          }
          if (massageFilters.lossTo) {
            massageFilters.lossTo = formatDisplayDateTime2(setEndTime(massageFilters.lossTo))
          }
          if (massageFilters.entryFrom) {
            massageFilters.entryFrom = formatDisplayDateTime2(removeTime(massageFilters.entryFrom))
          }
          if (massageFilters.entryTo) {
            massageFilters.entryTo = formatDisplayDateTime2(setEndTime(massageFilters.entryTo))
          }
          const result = await this.$http.get(filterQuery(expandURI(this.apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))

          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((claim) => {
                const convertClaim = {
                  clmRefNo: claim.clmRefNo,
                  polNo: claim.polNo,
                  proposalNo: claim.proposalNo,
                  clmNo: claim.clmNo,
                  product: claim.productName,
                  busCls: claim.busClsName,
                  cover: claim.cvrTypeName,
                  intermediary: claim.intermediaryName,
                  appName: claim.appName,
                  status: claim.status ? claimStatus[claim.status] : '',
                  statusCode: claim.status,
                  vehRegNo: claim.vehRegNo,
                  lossDate: this.formatDate(toDate(claim.lossDate)),
                  createdDate: this.formatDate(toDate(claim.createdDate)),
                  usrRefId: claim.usrRefId
                }
                this.items.push(convertClaim)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$set(this.params, 'intermediaries', result.data.intermediaries)
              this.$set(this.params, 'products', result.data.products)
              this.$set(this.params, 'busClses', result.data.busClses)
              this.$set(this.params, 'covers', result.data.covers)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doPromptUpdate() {
      if (this.selected.length > 0) {
        if (this.selectedStatus !== undefined && this.selectedStatus !== null && this.selectedStatus !== '') {
          this.promptUpdate = true
        } else {
          this.$snotify.warning('Please select the Status to be updated.')
        }
      } else {
        this.$snotify.warning('Please select record(s) to be updated.')
      }
    },
    async doUpdate() {
      const apiUrl = this.updateStatusState.menu.updateSelected
      if (apiUrl) {
        this.loading = true
        let updateForm = []
        this.selected.map(select => {
          updateForm.push(select.clmRefNo)
        })
        const expand = {
          status: this.selectedStatus
        }
        try {
          const result = await this.$http.post(expandURI(apiUrl, expand), updateForm)
          this.notify(result.data)

          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.loading = false
        }
        this.selected = []
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.clmRefNo = null
      this.filters.polNo = null
      this.filters.proposalNo = null
      this.filters.clmNo = null
      this.filters.intermediary = null
      this.filters.product = null
      this.filters.busCls = null
      this.filters.cover = null
      this.filters.appName = null
      this.filters.status = null
      this.filters.vehRegNo = null
      this.filters.lossFrom = null
      this.filters.lossTo = null
      this.filters.entryFrom = null
      this.filters.entryTo = null
      this.filters.usrRefId = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    }
  },
  created() {
    this.apiUrl = this.updateStatusState.menu.motor
    if (this.updateStatusState.statusList) {
      this.selectedStatus = this.updateStatusState.statusList[0].value
    }
    // Default some params from const
    this.$set(this.params, 'status', [{
      value: 'N',
      label: claimStatus['N']
    }, {
      value: 'A',
      label: claimStatus['A']
    }])
  },
  mixins: [
    updateStatusMixin
  ]
}
</script>

<style lang="scss">
</style>
